import React, {memo} from 'react';
import {CONTACT_EMAIL} from "../../LANDING_DATA";
import {Header} from "../../Components/Header";
import {Footer} from "../../Components/Footer";

export const PrivacyAndPolicy = memo(() => {
    return (
        <>
            <Header speed={2} limit={100}/>
            <div className="listing-header">
                <h1 className="hero-heading-text text-shadow">Privacy Policy</h1>
            </div>
            <div className="list-container">
                <div className="list-holder">

                    <div>
                        <p className="list-heading">1. Introduction</p>
                        <p className="list-values">
                            Kittxdev Technologies Private Limited ("Kittxdev", "we", "our", or "us") is committed to
                            protecting your privacy. This Privacy Policy outlines how we collect, use, and safeguard
                            your personal information across our websites and applications.
                        </p>
                    </div>

                    <div>
                        <p className="list-heading">2. What Personal Information We Collect</p>
                        <p className="list-values">
                            We may collect personal information that identifies you when you interact with our services.
                            This may include contact details, financial data for transactions, and other personally
                            identifiable information. Some information is mandatory to access specific features.
                        </p>
                    </div>

                    <div>
                        <p className="list-heading">3. Use and Disclosure of Information</p>
                        <p className="list-values">
                            We do not rent or sell your personal information. We may disclose it to comply with legal
                            obligations or requests from government or regulatory authorities.
                        </p>
                    </div>

                    <div>
                        <p className="list-heading">4. User Access to Personal Information</p>
                        <p className="list-values">
                            Registered users can manage and update their personal information and privacy preferences
                            via the account section of our site.
                        </p>
                    </div>

                    <div>
                        <p className="list-heading">5. Security Measures</p>
                        <p className="list-values">
                            We use industry-standard methods to protect your information, though no method is entirely
                            secure. Unauthorized access or other factors may compromise data, and by using our services,
                            you acknowledge this risk.
                        </p>
                    </div>

                    <div>
                        <p className="list-heading">6. Children’s Privacy</p>
                        <p className="list-values">
                            Our services are intended for users aged 18 and older. We do not knowingly collect personal
                            data from children under 13.
                        </p>
                    </div>

                    <div>
                        <p className="list-heading">7. Policy Updates</p>
                        <p className="list-values">
                            This Privacy Policy may be updated without prior notice. Continued use of our services after
                            changes constitutes your acceptance of the updated terms. Please review this page regularly.
                        </p>
                    </div>

                    <div>
                        <p className="list-heading">8. Acceptance & Contact Information</p>
                        <p className="list-values">
                            By using our site and services, you agree to the terms of this Privacy Policy. For any
                            questions, please contact us at <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
                        </p>
                    </div>

                </div>
            </div>
            <Footer/>
        </>
    );
});
